
import axios from "axios";
import { Toast } from "./utils";

const generateExcelReservacionCupo = async (data) => {
    try {
        const response = await axios.put(`/reports/generar_excel_cupos_reservados`, data, {
            headers: {
                'Content-Type': 'application/json',
            },
            responseType: 'blob',
        });

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `reservacion_cupos.xlsx`);
        document.body.appendChild(link);
        link.click();
        link.remove();
    } catch (error) {
        Toast.fire({
            icon: 'error',
            title: 'Error al descargar el archivo Excel', error
        })
    }
};

const generateExcelCuposNoReservados = async (data) => {
    try {
        const response = await axios.put(`/reports/generar_excel_cupos_no_reservados`, data, {
            headers: {
                'Content-Type': 'application/json',
            },
            responseType: 'blob',
        });

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `cupos_no_reservados.xlsx`);
        document.body.appendChild(link);
        link.click();
        link.remove();
    } catch (error) {
        console.log(error);
        Toast.fire({
            icon: 'error',
            title: 'Error al descargar el archivo Excel', error
        })
    }
};

const generateExcelContratos = async () => {
    try {
        const response = await axios.get(`/reports/contratos/generar_excel`, {
            headers: {
                'Content-Type': 'application/json',
            },
            responseType: 'blob',
        });

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `report_contracts.xlsx`);
        document.body.appendChild(link);
        link.click();
        link.remove();
    } catch (error) {
        console.log(error);
        Toast.fire({
            icon: 'error',
            title: 'Error al descargar el archivo Excel', error
        })
    }
};

const generateExceDocumentos = async () => {
    try {
        const response = await axios.get(`/reports/documentos/generar_excel`, {
            headers: {
                'Content-Type': 'application/json',
            },
            responseType: 'blob',
        });

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `report_documents.xlsx`);
        document.body.appendChild(link);
        link.click();
        link.remove();
    } catch (error) {
        console.log(error);
        Toast.fire({
            icon: 'error',
            title: 'Error al descargar el archivo Excel', error
        })
    }
};

const generateExceFormularios = async (form_id) => {
    try {
        const response = await axios.get(`/reports/formularios/generar_excel?form_id=${form_id}`, {
            headers: {
                'Content-Type': 'application/json',
            },
            responseType: 'blob',
        });

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `report_formularios.xlsx`);
        document.body.appendChild(link);
        link.click();
        link.remove();
    } catch (error) {
        console.log(error);
        Toast.fire({
            icon: 'error',
            title: 'Error al descargar el archivo Excel', error
        })
    }
};

export {
    generateExcelReservacionCupo,
    generateExcelCuposNoReservados,
    generateExcelContratos,
    generateExceDocumentos,
    generateExceFormularios
}